export const GLOBAL = 'global';
export const CONTAINER = 'container';

export type navigationLayer = typeof GLOBAL | typeof CONTAINER;
